import { Demography } from 'model/Demography';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'demography';

export namespace DemographyState {
  export type Domain = {
    list: Resource<Demography[]>;
  };

  export const INITIAL_DOMAIN: Domain = {
    // Start PENDING so selectLegalFilters* doesn't strip URL filters before the API response arrives
    list: Resource.createPendingResource([]),
  };
}

export type DemographyState = {
  demography: DemographyState.Domain;
};
